import React, { Fragment, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import ProfilePicture from "../ProfilePicture/ProfilePicture";
import { updateUser } from "../../Reducers/actions/authActions";
import { fetchUpdateProfilePic, fetchCheckEmail, fetchUpdateProfile, fetchCheckPassword } from "../../Reducers/actions/userActions";
import { validateEmail, getUsernameValidationMessage } from "../../../helpers/utilities";
import Icon from "../Icon/Icon";
import { useNavigate } from "react-router-dom";
import "./EditProfileV2.scss";
import { setHideBottomNav } from "../../Reducers/actions/navigationActions";

const Username = ({ userName: init_userName, onSave, onClose, error, loading }) => {

    const [username, setUsername] = useState(init_userName);

    return (
        <div className="add-creation__content edit-profile-content w-full">
            <div className="d-flex aic jcc profile-edit-header mb-8">
                <Icon alias={"chevron-left"} width={24} color="#0A0F1E" className={"p-absolute"} style={{ left: 16 }} onClick={onClose} />
                <span className="fg-black fw-bold fs-sm2">USERNAME</span>
                <button
                    className="btn btn-sm red-btn rounded-xl fs-xxs px-16 profile-edit-save-btn"
                    disabled={loading || username?.length === 0 || username === init_userName}
                    onClick={(e) => { e.preventDefault(); onSave(username); }}
                >
                    {loading ? "Saving..." : "Save"}
                </button>
            </div>
            <div className=" mt-16 mx-16">
                <input
                    type="text"
                    name="username"
                    placeholder="Username"
                    className="add-creation__input tt-uppercase"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                />
                {error && <p className='fs-real fw-medium fg-xtred ta-center mt-8'>{error}</p>}
            </div>
        </div>
    )
}

const FullName = ({ fullName: init_fullName, onSave, onClose, error, loading }) => {
    const [fullName, setFullName] = useState(init_fullName);

    return (
        <div className="add-creation__content edit-profile-content w-full">
            <div className="d-flex aic jcc profile-edit-header mb-8">
                <Icon alias={"chevron-left"} width={24} color="#0A0F1E" className={"p-absolute"} style={{ left: 16 }} onClick={onClose} />
                <span className="fg-black fw-bold fs-sm2">FULL NAME</span>
                <button
                    className="btn btn-sm red-btn rounded-xl fs-xxs px-16 profile-edit-save-btn"
                    disabled={loading || fullName?.length === 0 || fullName === init_fullName}
                    onClick={(e) => { e.preventDefault(); onSave(fullName) }}
                >
                    {loading ? "Saving..." : "Save"}
                </button>
            </div>
            <div className="mt-16 mx-16">
                <input
                    type="text"
                    name="fullName"
                    placeholder="Full Name"
                    className="add-creation__input tt-uppercase"
                    value={fullName}
                    onChange={(e) => setFullName(e.target.value)}
                />
                {error && <p className='fs-real fw-medium fg-xtred ta-center mt-8'>{error}</p>}

            </div>
        </div>
    )
}


const Bio = ({ bio: init_bio, onSave, onClose, error, loading }) => {

    const [bio, setBio] = useState(init_bio);

    return (
        <div className="add-creation__content edit-profile-content w-full">
            <div className="d-flex aic jcc profile-edit-header mb-8">
                <Icon alias={"chevron-left"} width={24} color="#0A0F1E" className={"p-absolute"} style={{ left: 16 }} onClick={onClose} />
                <span className="fg-black fw-bold fs-sm2">BIO</span>
                <button
                    className="btn btn-sm red-btn rounded-xl fs-xxs px-16 profile-edit-save-btn"
                    disabled={loading || bio?.length === 0 || bio === init_bio || bio.length > 1000}
                    onClick={(e) => { e.preventDefault(); onSave(bio) }}
                >
                    {loading ? "Saving..." : "Save"}
                </button>
            </div>
            <div className="mt-16 mx-16 p-relative">
                <textarea
                    className="add-creation__input textarea-main"
                    placeholder="Bio"
                    value={bio}
                    onChange={(e) => setBio(e.target.value)}
                    maxLength={1000}
                    rows={8}
                    style={{ height: '220px' }}
                    autoComplete="off"
                    autoCorrect="off"
                    autoCapitalize="sentences"
                    spellCheck="false"
                    data-form-type="other"
                    data-lpignore="true"
                    data-1p-ignore="true"
                />
                <span className="p-absolute fs-tiny fw-medium fg-grey" style={{ right: '12px', bottom: '12px' }}>{bio?.length || 0}/1000</span>

                {error && <p className='fs-real fw-medium fg-xtred ta-center mt-8'>{error}</p>}
            </div>
        </div>
    )
}


const Email = ({ email: init_email, onSave, onClose, error, loading }) => {
    const navigate = useNavigate();
    const [email, setEmail] = useState(init_email);
    const [step, setStep] = useState(1);
    const [showPwd, setShowPwd] = useState(false);
    const [password, setPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState(null);
    const [loadingEmail, setLoadingEmail] = useState(false);

    const handleContinue = () => {
        setErrorMessage(null)
        if (step === 1) {
            setLoadingEmail(true)
            fetchCheckPassword( password).then(({ success, data }) => {
                if (success && data) {
                    setStep(2)
                } else {
                    setErrorMessage("Password is incorrect")
                }
                setLoadingEmail(false)
            })
        } else {
            onSave(email)
        }
    }

    return (
        <div className="add-creation__content edit-profile-content w-full">
            <div className="d-flex aic jcc profile-edit-header mb-8">
                <Icon alias={"chevron-left"} width={24} color="#0A0F1E" className={"p-absolute"} style={{ left: 16 }} onClick={onClose} />
                <span className="fg-black fw-bold fs-sm2">CHANGE EMAIL ADDRESS</span>
                {/* <button
                    className="btn btn-sm red-btn rounded-xl fs-xxs p-fixed px-16" style={{ right: '16px' }}
                    disabled={loading || email?.length === 0}
                    onClick={(e) => { e.preventDefault(); onSave(email) }}
                >
                    {loading ? "Saving..." : "Save"}
                </button> */}
            </div>
            <div className="mt-16 mx-16">
                {step === 1 &&
                    <Fragment>
                        <div className="input-container mb-16">
                            <input
                                type={showPwd ? "text" : "password"}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Password"
                                className="input-main w-full"
                            />
                            <div className="input-icon" onClick={() => setShowPwd(prev => !prev)}>
                                <Icon alias={"show-password"} width={24} color="#777777" />
                            </div>
                        </div>
                        <p className="fs-xxs fw-bold fg-red mt-16 td-underline" onClick={() => navigate("/send-recover")}>FORGOT PASSWORD</p>
                    </Fragment>
                }
                {step === 2 && <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    className="add-creation__input"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />}
                {(error || errorMessage) && <p className='fs-real fw-medium fg-xtred ta-center mt-8'>{error || errorMessage}</p>}
                <button
                    className="btn red-btn btn-full-v d-flex aic jcc p-fixed"
                    onClick={handleContinue}
                    disabled={loading || loadingEmail || (step === 2 && email?.length === 0) || (step === 1 && password?.length === 0)}
                    style={{ bottom: '40px', left: '16px' }}>
                    {loadingEmail ? "Checking..." : "CONTINUE"}
                </button>
            </div>
        </div>
    )
}

const EmailChanged = ({ email, onClose }) => {
    const handleResetLink = () => {
        // Handle resend email logic here
        console.log('Resending email to:', email);
    };

    return (
        <div className="add-creation__content edit-profile-content w-full">
            <div className="d-flex aic jcc profile-edit-header mb-8">
                <Icon alias={"chevron-left"} width={24} color="#0A0F1E" className={"p-absolute"} style={{ left: 16 }} onClick={onClose} />
                <span className="fg-black fw-bold fs-sm2">CHANGE EMAIL ADDRESS</span>
            </div>
            <div className="mt-40 mx-32 d-flex f-column aic jcc">
                <Icon alias={"check-your-email"} height={200} width={200} />
                <p className="fs-sm2 fw-bold fg-dark mt-40">Check your email</p>
                <p className="fw-medium fg-grey7 mt-16 ta-center">We sent an email to {email}, tap the link to confirm your new email address.</p>
                <div className="send-again ta-center">
                    <p className='fg-crea fs-xxs fw-medium'>You didn't receive our email? <span className="c-pointer fg-red-pink fs-xxs link-btn fw-bold" onClick={handleResetLink}>SEND AGAIN</span></p>
                    {/* <p className="c-pointer fg-red-pink link-btn" onClick={handleContactHelp}>Contact help center</p> */}
                </div>
            </div>
        </div>
    )
}


const EditProfileV2 = ({ init_user }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [openEditInput, setOpenEditInput] = useState(null);

    const [errorMessage, setErrorMessage] = useState(null);

    const [loading, setLoading] = useState(false);

    useEffect(() => () => {
        dispatch(setHideBottomNav(false));
    }, [dispatch]);

    /** Treat null, undefined, and literal "null" as empty so we never show "null" in the UI. */
    const sanitizeNamePart = (value) => {
        if (value == null) return "";
        const s = String(value).trim();
        if (s === "" || s.toLowerCase() === "null") return "";
        return s;
    };

    const constructFullName = (firstName, lastName) => {
        const f = sanitizeNamePart(firstName);
        const l = sanitizeNamePart(lastName);
        if (!f && !l) return "";
        return f + (f && l ? " " : "") + l;
    };

    // Helper function to parse fullName back into firstName and lastName
    const parseFullName = (fullName) => {
        if (!fullName || fullName.trim().length === 0) {
            return { firstName: "", lastName: "" };
        }
        
        const nameParts = fullName.trim().split(/\s+/);
        const firstName = nameParts[0] || "";
        const lastName = nameParts.slice(1).join(" ") || "";
        
        return { firstName, lastName };
    };

    const onImageUpload = (obj) => {
        fetchUpdateProfilePic(obj, init_user.user_id).then(({ success, data }) => {
            if (success) {
                dispatch(updateUser({ ...init_user, profilePicture: data }));
                localStorage.setItem("pdp", data);
            }
        });
    };



    const handleSubmit = (value, type) => {
        const BreakException = {};
        setLoading(true)
        setErrorMessage(null)
        try {
            // Check for validation errors before submitting
            if (type === 'userName' && value?.length > 0) {
                const usernameError = getUsernameValidationMessage(value);
                if (usernameError) {
                    setLoading(false)
                    setErrorMessage(usernameError);
                    return; // Don't submit if username is invalid
                }
            }

            // Check email validation if email is being edited
            if (type === 'email') {
                if (value?.length > 0 && !validateEmail(value)) {
                    setLoading(false)
                    setErrorMessage("Enter a valid email");
                    return;
                }

            }

            const changedFields = {
                ...(type === 'userName' && { userName: value?.toUpperCase() || "" }),
                ...(type === 'email' && { email: value }),
                ...(type === 'fullName' && parseFullName(value)),
                ...(type === 'bio' && { bio: value }),
            }


            fetchUpdateProfile(changedFields, init_user.user_id).then(({ success, message, user: newUser }) => {
                if (success) {
                    dispatch(updateUser({ ...init_user, ...newUser }))
                    openEdit(type === 'email' ? 'email_changed' : null)
                    setLoading(false)
                } else {
                    setErrorMessage(message?.length > 0 ? message : "Something went wrong")
                    setLoading(false)
                }
            })

        } catch (e) {
            console.log(e)
            return;
        }
    };


    const openEdit = (value) => {
        dispatch(setHideBottomNav(!!value))
        setOpenEditInput(value)
    }

    const pdp = localStorage.getItem("pdp");
    const fullName = constructFullName(init_user.firstName, init_user.lastName);
    return (
        openEditInput === null ? <div className="d-flex f-column aic w-full">
            <ProfilePicture
                imgUrl={!pdp || pdp === 'null' || pdp.length === 0 ? init_user?.profilePicture : pdp}
                onImageUpload={onImageUpload}
                showIcon={true}
                width={112}
                height={112}
                classNames={'mb-12 mt-40'}
            />
            <p className='fg-black fw-medium mt-0 mb-24'>{fullName}</p>
            <div className="modify-form w-full">
                <div className="d-flex aic">
                    <span className="modify-info">Username</span>
                    <p className="input-main text" onClick={() => openEdit("userName")}>{init_user.userName}</p>
                </div>
                <div className="d-flex aic">
                    <span className="modify-info">Full name</span>
                    <p className="input-main text" onClick={() => openEdit("fullName")}>{fullName}</p>
                </div>
                <div className="d-flex aic mb-40">
                    <span className="modify-info">Bio</span>
                    <p className="input-main text" onClick={() => openEdit("bio")}>{init_user.bio}</p>
                </div>

                <p className="fg-red fs-real fw-medium mb-16" onClick={() => openEdit("email")}>Change email address</p>
                <p className="fg-red fs-real fw-medium" onClick={() => navigate("/change-password")}>Change password</p>
            </div>
        </div>
            :
            openEditInput === 'userName' ? <Username userName={init_user.userName} onSave={(v) => handleSubmit(v, 'userName')} error={errorMessage} onClose={() => openEdit(null)} loading={loading} />
                : openEditInput === 'fullName' ? <FullName fullName={constructFullName(init_user.firstName, init_user.lastName)} onSave={(v) => handleSubmit(v, 'fullName')} error={errorMessage} onClose={() => openEdit(null)} loading={loading} />
                    : openEditInput === 'bio' ? <Bio bio={init_user.bio} onSave={(v) => handleSubmit(v, 'bio')} error={errorMessage} onClose={() => openEdit(null)} loading={loading} />
                        : openEditInput === 'email' ? <Email email={init_user.email} onSave={(v) => handleSubmit(v, 'email')} error={errorMessage} onClose={() => openEdit(null)} loading={loading} />
                            : openEditInput === 'email_changed' ? <EmailChanged email={init_user.email} onClose={() => openEdit(null)} />
                            : null
    );
};

export default EditProfileV2;